import iconEvent from 'assets/images/eventBunpimay/iconTextEvent.png'
import iconTopRight from 'assets/images/eventBunpimay/iconTopRight.png'
import iconTopLeft from 'assets/images/eventBunpimay/iconTopLeft.png'
import CustomTable from 'pages/Event/EventWater/CustomTable'
import iconTop1 from 'assets/images/eventBoatRacing/iconTop1.png'
import iconTop2 from 'assets/images/eventBoatRacing/iconTop2.png'
import iconTop3 from 'assets/images/eventBoatRacing/iconTop3.png'
import { useTranslation } from 'react-i18next'
import { useEffect, useState } from 'react'
import { useQuery } from 'react-query'
import { getRankEventBoatRacingQuery, getRankEventBunpimayQuery } from 'dataLayer/game'
import { getUserQuery } from 'dataLayer/user'
import noDataIcon from 'assets/images/profilepage-gifthist-nodata.svg'
import { Pagination } from '@material-ui/lab'

function EventBunpimayRank() {
	const { t } = useTranslation()
	const [current, setCurrent] = useState(1)
	const [dataTableRanks, setDataTableRanks] = useState([])
	const [dataTableMyRanks, setDataTableMyRanks] = useState([])
	const [totalPages, setTotalPages] = useState(0)
	const [pageSize, setPageSize] = useState(10)
	const { data: user, isLoading: isUserLoading } = useQuery(getUserQuery())
	const [isFetchingRank, setIsFetchingRank] = useState(false)
	let showMyRank = 0
	if (user) {
		showMyRank = 1
	}


	const {
		data: rankBunpimay,
		isLoading: isLoadingRank,
		refetch: refetchRank
	} = useQuery(getRankEventBunpimayQuery(current, showMyRank, pageSize, isFetchingRank))
	const onChangePage = page => {
		setCurrent(page)
	}
	useEffect(() => {
		if (isUserLoading) {
			setIsFetchingRank(false)
		} else {
			setIsFetchingRank(true)
		}
	}, [isUserLoading])
	useEffect(() => {

		if (rankBunpimay && rankBunpimay.ranks && +rankBunpimay.ranks.total) {
			const total = Math.floor(+rankBunpimay?.ranks.total / pageSize)
			console.log(total, +rankBunpimay?.ranks.total % pageSize);
			if (+rankBunpimay?.ranks.total % pageSize) {

				setTotalPages(total + 1)
			} else {
				setTotalPages(total)
			}
		}

		if (!isLoadingRank && rankBunpimay && rankBunpimay.ranks && rankBunpimay.ranks.data.length > 0) {
			const newRankList = rankBunpimay?.ranks.data.map((item, index) => ({
				...item,
				rank: index + 1 + (current - 1) * pageSize,
			}))
			console.log('newRankList', newRankList)
			setDataTableRanks(newRankList)
		}

		if (user && rankBunpimay?.myRank) {
			const myRank = {
				...rankBunpimay?.myRank,
				rank: rankBunpimay?.myRank?.position,
			}
			console.log('myRank', myRank)
			setDataTableMyRanks([myRank])
		} else {
			setDataTableMyRanks([])
		}
	}, [isLoadingRank, pageSize, rankBunpimay])
	const listImgRank = {
		1: iconTop1,
		2: iconTop2,
		3: iconTop3,
	}
	const columnsRank = [
		{
			title: t('event.bunpimay.rank.rank'),
			width: '12%',
			dataIndex: 'rank',
			align: 'center',
			render: text => {
				if (text == 1 || text == 2 || text == 3) {
					return (
						<div
							style={{
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
							}}
						>
							<img src={listImgRank[text]} />
						</div>
					)
				} else {
					return text
				}
			},
		},
		{
			title: t('event.bunpimay.rank.name'),
			width: '25%',
			dataIndex: 'full_name',
			align: 'center',
			render: (text, row) => {
				if (!text || text === '0') {
					return row.msisdn
				}
				return text
			},
		},
		{
			title: t('event.bunpimay.rank.isdn'),
			width: '25%',
			dataIndex: 'msisdn',
			align: 'center',
		},
		{
			title: t('event.bunpimay.rank.water_gun'),
			width: '20%',
			dataIndex: 'water_guns',
			align: 'center',
		},
		{
			title: t('event.bunpimay.rank.gun_bodies'),
			width: '20%',
			dataIndex: 'gun_bodies',
			align: 'center',
		},
	]
	return (
		<div className="box-rank">
			<div className="box-rank-description">
				<img
					draggable="false"
					className="icon-event"
					srcSet={`${iconEvent} 2x`}
				/>
			</div>
			<div className="box-rank-table">
				<img draggable="false" className='icon-top-right' src={iconTopRight} />
				<img draggable="false" className='icon-top-left' src={iconTopLeft} />
				<div className="wapper-detail-box">
					<CustomTable
						columns={columnsRank}
						dataSource={dataTableRanks}
						pagination={false}
						scroll={{ x: true }}
						className="table-rank"
						rowClassName={(record, index) => {
							if (record.msisdn === user?.msisdn) {
								return 'row-current-user'
							}
						}}
						bordered
					/>
					{dataTableRanks.length === 0 && !isLoadingRank && (
						<div className="wapper-detail-box-nodata">
							<img
								className="img--no-data"
								src={noDataIcon}
								alt="No reward is found"
							/>
						</div>
					)}
					{totalPages > 1 && (
						<div className="wapper-detail-box-pagination">
							<Pagination
								count={totalPages}
								shape="rounded"
								size="small"
								page={current || 1}
								onChange={(event, page) => onChangePage(page)}
							/>
						</div>
					)}
					{user && !isLoadingRank && dataTableMyRanks?.length > 0 ? (
						<div className="wapper-detail-box-current-rank">
							<div className="wapper-detail-box-current-rank-title">
								{t('event.bunpimay.rank.my_rank')}
							</div>
							<CustomTable
								columns={columnsRank}
								dataSource={dataTableMyRanks}
								pagination={false}
								scroll={{ x: true }}
								isShowTitle={false}
								bordered
								className="table-rank-current"
							/>
						</div>
					) : null}
				</div>
			</div>
		</div>
	)
}

export default EventBunpimayRank
